import React from "react";
import { Box, Button, Stack, TextField, Typography, Paper } from "@mui/material";
import CodeOutlinedIcon from "@mui/icons-material/CodeOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import { toast } from "react-toastify";
import { MANAGER_COLORS, outlinedButtonSx, helperCaptionSx } from "./managerTheme.js";

const JsonPreviewPanel = ({ overrideJson, doctorId }) => {
  const pretty = JSON.stringify(overrideJson, null, 2);

  const handleCopy = () => {
    navigator.clipboard.writeText(pretty);
    toast.success("Copied JSON to clipboard");
  };

  const handleDownload = () => {
    const blob = new Blob([pretty], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = `doctor_console_config_${doctorId ?? "draft"}.json`;
    anchor.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Box>
      <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 1.5 }}>
        <CodeOutlinedIcon sx={{ fontSize: 18, color: MANAGER_COLORS.primary }} />
        <Typography variant="subtitle2" sx={{ fontWeight: 600, color: MANAGER_COLORS.primaryDark }}>
          Configuration JSON
        </Typography>
      </Stack>
      <Typography sx={{ ...helperCaptionSx, mb: 2 }}>
        Read-only preview of the override payload that will be saved. Use this for debugging or
        external review.
      </Typography>

      <Stack direction="row" gap={1} mb={1.5}>
        <Button
          size="small"
          variant="outlined"
          startIcon={<ContentCopyOutlinedIcon />}
          onClick={handleCopy}
          sx={outlinedButtonSx}
        >
          Copy JSON
        </Button>
        <Button
          size="small"
          variant="outlined"
          startIcon={<DownloadOutlinedIcon />}
          onClick={handleDownload}
          sx={outlinedButtonSx}
        >
          Download .json
        </Button>
      </Stack>

      <Paper
        elevation={0}
        sx={{
          border: `1px solid ${MANAGER_COLORS.border}`,
          borderRadius: 1.5,
          overflow: "hidden",
          bgcolor: MANAGER_COLORS.codeBg,
        }}
      >
        <TextField
          multiline
          fullWidth
          value={pretty}
          InputProps={{
            readOnly: true,
            disableUnderline: true,
            sx: {
              fontFamily: '"Consolas", "Monaco", "Courier New", monospace',
              fontSize: 12,
              lineHeight: 1.6,
              p: 2,
              color: MANAGER_COLORS.primaryDark,
            },
          }}
          variant="standard"
          minRows={20}
          maxRows={40}
        />
      </Paper>
    </Box>
  );
};

export default JsonPreviewPanel;
